export default __webpack_public_path__ + "static/media/activity-2.78b1c365.png";